import MicroModal from 'micromodal';

export default function () {
  const widgetName = 'managedPopUp';
  const widgetOpts = managedPopUpOpts;

  // Content options-------------
  const widgetImage = true; // False > will remove local theme logo .
  const themeLogo = "logo.png"; // empty > will remove image from widget and apply alignment center.
  const logoPath = `${FULLCLIENTTHEMEPATH}images/` // alternative path if a logo inside of theme folder is required

  // Storage selector-------------
  const sectionTrigger = "homepage";
  const cookiesTimeStamp = 7;

  const buttonText = "More"; // Button text
  const targetBlankUrl = true; // alt attribute

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      const showThemeLogo = themeLogo == "" ? "" : `<img class="modal-logo" src="${logoPath}${themeLogo}">`;

      const d = data.items[0];
      const title = d.Title;
      const description = d.Description == null ? "" : `<p class="modal__description">${d.Description}</p>`;
      const img = !d.ImageWithPath ? "" : widgetImage ? `<div class="modal__content-left"><img src="${!(d.ImageWithPath) ? "" : d.ImageWithPath}"></div>` : '';
      const url = d.URL == null ? "" : `<a href="${d.URL}" class="button" ${targetBlankUrl ? 'target="_blank"' : ''}>${buttonText}</a>`;

      function initializePopupModal() {
        $('body').append(`
            <div class="micromodal-slide" id="modal" aria-hidden="true">
              <div class="modal__overlay" tabindex="-1">
                <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-title">
                  <label class="modal-close-btn" data-micromodal-close>X</label>
                    <header class="modal__header">
                      ${showThemeLogo} 
                    </header>
                  <div class="modal__content" id="modal-content">
                    ${img}
                    <div class="modal__content-right ${!d.ImageWithPath ? 'noImagesAlignment' : 'imagesAlignment'}">
                      <h2 class="modal__title" id="modal-title">${title}</h2>
                      ${description}
                      ${url}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          `);
        MicroModal.show('modal');
        sessionStorage.setItem('modalShown', 'true'); // Set session storage flag
      }

      // Check if pop-up has already been shown during this session
      const modalShown = sessionStorage.getItem('modalShown');

      // Show pop-up only if on homepage and not already shown during this session
      if ($('body').hasClass(sectionTrigger) && window.location.pathname === '/' && modalShown !== 'true') {
        initializePopupModal();
      }
    },

    itemsPerPanel: 1,
    link: [],
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
  });
}
